import { render, staticRenderFns } from "./CustomDevices.vue?vue&type=template&id=44c8c491&scoped=true&lang=pug"
import script from "./CustomDevices.vue?vue&type=script&lang=js"
export * from "./CustomDevices.vue?vue&type=script&lang=js"
import style0 from "./CustomDevices.vue?vue&type=style&index=0&id=44c8c491&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c8c491",
  null
  
)

export default component.exports